module.exports = "/_next/static/images/c443740871dcab1a4e4d188d13743961-david-desktop.jpg.webp";